function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M431 272c44 0 80 34 81 77v78H351v-78c0-43-9-65-39-77zM0 349c0-43 36-77 80-77h160c44 0 80 34 80 77v78H0zm239-187c0-43-35-77-77-77s-77 34-77 77c0 42 35 77 77 77s77-35 77-77zm199 0c0-43-34-77-77-77-42 0-77 34-77 77 0 42 35 77 77 77 43 0 77-35 77-77z"
})));